import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class SideBarService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
    })
  };
  version = 'v1.0';
  url = environment.apiUrl + this.version + '/Authenticate';
  constructor(private http: HttpClient) {}
  getMenu(): Observable<any> {
    return this.http.get(this.url + '/GetMenu2');
  }
}
